import { RainSystemMeasurementsDto } from '../../../../../api/models/rain-system-measurements-dto';

export const rainSystemDefaultState: RainSystemMeasurementsDto | any = {
  rainSystem: false,
  eavesDescents: null,
  groundToEavesHeight: null,
  color: null,
  finish: null,
  diameter: null,
};
